export default __webpack_public_path__ + "fonts/search-white-color-icon.svg";